import { Component, OnInit, OnDestroy, ViewChild, ElementRef } from '@angular/core';
import { Router } from '@angular/router';
import { ApiService } from 'src/app/api.service';
import { Banner } from 'src/models/banner.model';
import anime from 'animejs/lib/anime.es';
import { ResizeService } from 'src/app/shared/services/resize.service';
import { BehaviorSubject, Subscription } from 'rxjs';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { emailValidator } from 'src/app/shared/utils/app-validators';
import { SwalService } from 'src/app/shared/services/swal.service';
import { RecaptchaService } from 'src/app/shared/services/recaptcha.service';


@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})


export class HomeComponent implements OnInit, OnDestroy {
  banners?:Banner[];
  currentSlideIndex: number = 0;
  interval: any;
  hover: boolean = false;
  destaques: any;
  qntProducts = 12;
  placeholderCards:any[] = []
  showedAll = false;
  categories: any;
  listPosts: any[] = [];
  allPosts: any[] = [];
  currentIndex: number = 0;
  subscriptions: Subscription[] = [];
  countChanges = 0;
  formNewsletter: FormGroup = new FormGroup({});
  submitted = false;
  inputSearchProductsOff = true;
  tutorial = true;
  isInputFocused: boolean = false;

  products: any;
  searchString = '';
  timer: any;
  addProducts = 12;

  loadingProducts: boolean = false;
  autoProductSearch: any = null;

  tokenRecapchaValid = false;
  private subscription!: Subscription;
  @ViewChild('productFirst') productFirst!: ElementRef;

  private tutorialKey = 'tutorial';
  private tutorialSubject!: BehaviorSubject<boolean>;
  tutorialEnabled: boolean = false;

  constructor(
    public apiService:ApiService,
    private route: Router,
    public resizeService: ResizeService,
    private fb: FormBuilder,
    public swalService: SwalService,
    private recaptchaService: RecaptchaService
    ) {
      this.tutorialSubject = new BehaviorSubject<boolean>(this.getTutorialValue());

      for (let i = 0; i < this.qntProducts; i++) {
        this.placeholderCards.push({})
      }
     }

  ngOnInit() {
    this.tutorialSubject.subscribe(value => {
      this.tutorialEnabled = value;
    });
    let bannersSubscription = this.apiService.loadBanners().subscribe((result:any) =>
      {
        this.banners = result
      }
    );
    this.subscriptions.push(bannersSubscription)
    this.loadDestaques();
    this.loadCategories();
    this.loadBlog();

    this.formNewsletter = this.fb.group({
      nome: ['', [Validators.required, Validators.minLength(3)]],
      email: [null, Validators.compose([Validators.required, emailValidator])]
    });

    this.verifyToken();
  }

  private getTutorialValue(): boolean {
    const value = localStorage.getItem(this.tutorialKey);
    return value === 'true';
  }

  toggleTutorial() {
    this.setTutorialValue(!this.tutorialEnabled);
  }

  setTutorialValue(value: boolean): void {
    localStorage.setItem(this.tutorialKey, value.toString());
    this.tutorialSubject.next(value);
  }


  showSlide(index: number) {
    this.currentSlideIndex = index;
  }


  stopCarousel() {
    clearInterval(this.interval);
  }

  showNextSlide() {
    if (this.banners) {
      this.currentSlideIndex = (this.currentSlideIndex + 1) % this.banners.length;
    }
  }

  async loadProducts(){
    this.products = await this.apiService.loadProducts();
  }

  onFocus(){
    this.isInputFocused = true;
  }

  onInputBlur(){
    this.inputSearchProductsOff = true;
    setTimeout(() =>{
      this.isInputFocused = false;
    }, 500)

  }

  searchProducts() {
    if(this.searchString.length <= 1){
      this.products = [];

      return
    }
    this.loadingProducts = true;
      this.apiService.loadProductsFilter()
      .subscribe(
      lista =>
        {
        this.products = this.apiService.filterProducts(lista, this.searchString);
        this.loadingProducts = false;
        }
      );
  }

  onKeyDownEvent(event: any){
    this.showedAll = false;
    this.inputSearchProductsOff = false;
    clearTimeout(this.timer);


    this.timer = setTimeout(() => {
      this.searchString = event.target.value;
      this.searchProducts();
  }, 500);

    // this.searchProducts(event.target.value);
  }

  addProductsFiltered(){
    if(this.products.length > this.addProducts + 1){
      this.addProducts = this.addProducts + 15;
    } else {
      this.addProducts = this.products.length - 1;
      this.showedAll = true;
    }
  }

  async loadDestaques (){
    this.destaques = await this.apiService.loadProducts();
    this.destaques = this.destaques.filter((res: any) => res.destacar == 1)

    // this.destaques.sort((a: any, b: any) => {
    //   if (b.novo - a.novo !== 0) {
    //       return b.novo - a.novo;
    //   }
    //   return 0;
    // });

    await this.destaques.map(async (i:any) => {
      i.resizedImageUrl = await this.resizeService.getUrlResized(i.IMGPR1);
    })
    this.showedAll = false;
  }

  loadCategories(){
    this.apiService.loadCategories().then(result => {
      this.categories = result;
    })
  }

  goToProductDetail(param: string){
    this.route.navigate([`produto-detalhe/${param}`])
  }

  onEnter(event: any){
    if (event.keyCode === 13) {
      event.preventDefault();
      if(this.loadingProducts && this.autoProductSearch == null){
        let timeOut = 10000;
        let retryTime = 200;

        let currentTime = 0;

        this.autoProductSearch = setInterval(() => {
          console.log('interval)')
          if (this.products && this.loadingProducts == false){
            clearInterval(this.autoProductSearch);
            this.autoProductSearch = null;
            if(this.products.length == 1){
              this.goToProductDetail(this.products[0].slug ? this.products[0].slug : this.products[0].codPro);
            }
          }
          currentTime += retryTime
          if(currentTime > timeOut){
            clearInterval(this.autoProductSearch);
            this.autoProductSearch = null;
          }
        }, retryTime)
      } else {
        if(this.products && this.products.length == 1){
          this.goToProductDetail(this.products[0].slug ? this.products[0].slug : this.products[0].codPro );
        }
      }
    }

  }

  loadBlog() {
    let postsSubscription = this.apiService.loadPosts().subscribe((data) => {
      this.allPosts = data;
      this.allPosts.forEach((post) => {
        post.cover = this.apiService.getCover(post);
      })
      if(data && data.length <= 6){
        this.listPosts = data;
        this.currentIndex = this.listPosts.length;
      }else if(data && data.length > 6){
        this.listPosts = data.slice(0,6);
        this.currentIndex = this.listPosts.length;
      }
      this.interval = setInterval(() => this.changeItems(), 5000);
    });

    this.subscriptions.push(postsSubscription);

  }

  changeItems(){
    const postsRemaining = this.allPosts.slice(this.currentIndex);
    const nextPosts = postsRemaining.slice(0, 6);
    if (nextPosts.length === 0) {
      this.currentIndex = 0;
    } else {
      anime({
        targets: '#grid-posts',
        translateX: -200,
        opacity: 0,
        duration: 300,
        easing: 'easeInOutQuad',
        complete: (anim:any) => {
          this.listPosts = nextPosts;

          anime({
            targets: '#grid-posts',
            translateX: 0,
            opacity: 1,
            duration: 300,
            easing: 'easeInOutQuad',
          });
        }
      });
      this.currentIndex += nextPosts.length;
    }
    this.countChanges++
    if(this.countChanges > 10)
      this.stopCarousel();
  }

  loadMorePosts(quantity:number){
    const sliceStart = this.listPosts.length;

    let sliceEnd:number;
    if(this.allPosts.length >= this.listPosts.length + quantity){
      sliceEnd = this.listPosts.length + quantity;
    }else{
      sliceEnd = this.allPosts.length;
    }
    this.listPosts = [...this.listPosts, ...this.allPosts?.slice(sliceStart, sliceEnd)];
  }
  addMoreProducts(){
    if(this.destaques.length > this.qntProducts + 1){
      this.qntProducts = this.qntProducts + 12;
      if(this.destaques.length <=  this.qntProducts){
        this.showedAll = true;
      }
    } else {
      // this.qntProducts = this.destaques.length - 1;
      this.showedAll = true;
    }
  }

  getIconUrl(category:any){
    if(category.icon_url){
      return category.icon_url
    }
    return "/assets/icons/Logo.png"
  }

  verifyToken() {
    this.subscription = this.recaptchaService.verifyTokenReCaptcha().subscribe(res => {
      this.tokenRecapchaValid = res.success;
    }, error => {
      console.error(error);
    });
  }

  registerNewsletter(formNewsletter: any){
    this.submitted = true;

    if(!this.tokenRecapchaValid){
      this.swalService.fireErrorSwal('Erro', 'Desculpe! Estamos com dificuldade em validar seus dados, pode ficar tranquilo que vamos trabalhar para resolver o problema o mais rapido possível. Ainda assim você pode usar outras alternativas como nos contatar diretamente pelo email falecom@blukit.com.br e se puder informe que teve problemas ao usar o site. Obrigado!');
      return;
    }

    this.apiService.registerNewsletter(formNewsletter.value).subscribe(
      (response: any) => {
        this.formNewsletter.reset();
          this.formNewsletter.controls['nome'].setErrors(null);
          this.formNewsletter.controls['email'].setErrors(null);
        this.swalService.homeFireSuccessSwal('Enviado com sucesso!');
      },

      (error: any) => {
        this.swalService.fireErrorSwal('Formulário não enviado','Tente novamente mais tarde.')
      });

  }

  isMobile(): boolean {
    const userAgent = navigator.userAgent || navigator.vendor;
    return /android|iPad|iPhone|iPod|blackberry|IEMobile|opera mini|windows phone/i.test(userAgent);
  }

  ngOnDestroy(){
    this.stopCarousel();
    this.subscriptions.forEach(subscription => subscription.unsubscribe);
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }
}
